import { render, staticRenderFns } from "./TServRedPacketComp.vue?vue&type=template&id=0d8fddbc&"
import script from "./TServRedPacketComp.vue?vue&type=script&lang=js&"
export * from "./TServRedPacketComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports